import { render } from "./PasswordUpdateDialog.vue?vue&type=template&id=a0bcdbb6&scoped=true"
import script from "./PasswordUpdateDialog.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateDialog.vue?vue&type=script&lang=js"

import "./PasswordUpdateDialog.vue?vue&type=style&index=0&id=a0bcdbb6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0bcdbb6"]])

export default __exports__